import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ArrowRightIcon, PhoneIcon } from 'lucide-react';
export function FinalCTA() {
  const ref = useRef(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section id="cta" className="relative bg-navy-950 overflow-hidden" data-id="element-139">
      {/* Decorative */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-140">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-amber/5 rounded-full blur-3xl" data-id="element-141" />
        <div className="absolute bottom-0 right-1/4 w-72 h-72 bg-navy-700/20 rounded-full blur-3xl" data-id="element-142" />
      </div>

      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 py-20 md:py-28 text-center" ref={ref} data-id="element-143">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} data-id="element-144">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white font-heading tracking-tight" data-id="element-145">
            Your First Week Is On Us
          </h2>
          <p className="mt-5 text-lg text-white/70 leading-relaxed max-w-xl mx-auto" data-id="element-146">
            Experience everything NTA has to offer — one full week of classes,
            completely free. No commitment, no pressure. Just show up and see
            the difference.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-147">
            <a href="#" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-amber text-navy-950 font-bold text-base rounded-lg hover:bg-amber-light transition-colors focus:outline-none focus:ring-2 focus:ring-amber focus:ring-offset-2 focus:ring-offset-navy-950 w-full sm:w-auto" data-id="element-148">
              Claim Your Free Week
              <ArrowRightIcon className="w-4 h-4" data-id="element-149" />
            </a>
          </div>

          <div className="mt-6 flex items-center justify-center gap-2 text-white/50" data-id="element-150">
            <PhoneIcon className="w-4 h-4" data-id="element-151" />
            <span className="text-sm" data-id="element-152">
              Or call us at{' '}
              <a href="tel:817-581-1419" className="text-white/70 font-semibold hover:text-white transition-colors" data-id="element-153">
                817-581-1419
              </a>
            </span>
          </div>
        </motion.div>
      </div>

      {/* Bottom edge */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-amber/20 to-transparent" data-id="element-154" />
    </section>;
}